import React, { useState } from 'react'
import './Mint.css'
import MintModal from '../MintModal'

export default function Mint() {
    const [mintModal, toggleMintModal] = useState(false)
    //<div onClick={() => toggleMintModal(true)} className="mint__container"> //TO OPEN MINT MODAL
    return (
        <div className="mint">
            <div
                onClick={() => toggleMintModal(true)}
                className="mint__container"
            ></div>
            <MintModal
                shown={mintModal}
                close={() => {
                    toggleMintModal(false)
                }}
            ></MintModal>
        </div>
    )
}
